import { Injectable } from '@angular/core';
import { ScrollNavTargetDirective } from './scroll-nav-target.directive';
import { BehaviorSubject } from 'rxjs';
import isEqual from 'lodash-es/isEqual';
import uniqBy from 'lodash-es/uniqBy';
import { TimeoutService } from '@df/ng/timeout.service';

@Injectable()
export class ScrollNavScope {
    private targets = new Set<ScrollNavTargetDirective>();

    readonly focus$ = new BehaviorSubject<ScrollNavTargetDirective | undefined>(undefined);
    readonly targets$ = new BehaviorSubject<ScrollNavTargetDirective[]>([]);
    private visibleTargets = new Set<ScrollNavTargetDirective>();

    constructor(private timeoutService: TimeoutService) {}

    register(target: ScrollNavTargetDirective) {
        if (!this.targets.has(target)) {
            this.targets.add(target);
            this.updateTargets();
        }
    }

    unregister(target: ScrollNavTargetDirective) {
        if (this.targets.has(target)) {
            this.targets.delete(target);
            this.updateTargets();
        }
    }

    visibilityChange(target: ScrollNavTargetDirective, visible: boolean) {
        if (visible) {
            this.visibleTargets.add(target);
        } else {
            this.visibleTargets.delete(target);
        }
        this.updateFocus();
    }

    private updateFocus = this.timeoutService.debounce(() => {
        const focus = this.targets$.value.find(target => this.visibleTargets.has(target));
        if (this.focus$.value !== focus) {
            this.focus$.next(focus);
        }
    }, 100);

    private updateTargets = this.timeoutService.debounce(() => {
        const targets = Array.from(this.targets);
        const tops = new Map<ScrollNavTargetDirective, number>();
        targets.forEach(target => {
            tops.set(target, target.getTopPosition());
        });

        const sortedTargest = targets.sort((a, b) => tops.get(a)! - tops.get(b)!);
        if (!isEqual(sortedTargest, this.targets$.value)) {
            this.targets$.next(uniqBy(sortedTargest, target => target.scrollNavTarget));
        }
        this.updateFocus();
    }, 100);
}
